import { forwardRef, type SVGProps } from 'react';

export interface TextAlignStartIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const TextAlignStartIcon = forwardRef<SVGSVGElement, TextAlignStartIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M11.3335 12.104C11.6441 12.1041 11.896 12.3559 11.896 12.6665C11.8959 12.977 11.644 13.2289 11.3335 13.229H2C1.68939 13.229 1.43759 12.9771 1.4375 12.6665C1.4375 12.3558 1.68934 12.104 2 12.104H11.3335ZM10 7.43701C10.3106 7.43701 10.5624 7.68893 10.5625 7.99951C10.5625 8.31017 10.3107 8.56201 10 8.56201H2C1.68934 8.56201 1.4375 8.31017 1.4375 7.99951C1.43759 7.68893 1.68939 7.43701 2 7.43701H10ZM14 2.77051C14.3107 2.77051 14.5625 3.02235 14.5625 3.33301C14.5625 3.64367 14.3107 3.89551 14 3.89551H2C1.68934 3.89551 1.4375 3.64367 1.4375 3.33301C1.4375 3.02235 1.68934 2.77051 2 2.77051H14Z"
      fill="currentColor"
    />
  </svg>
));

TextAlignStartIcon.displayName = 'TextAlignStartIcon';
